// Helper: transforma URLs em texto em fragmentos com <a> clicáveis.
// Detecta http(s) e mailto. Mantém pré-formatação (\n) com whitespace-pre-wrap
// no container externo.

import { Fragment, type ComponentChildren } from "preact";

const URL_RE = /(https?:\/\/[^\s<>"']+|mailto:[^\s<>"']+)/g;

/** Quebra string em fragmento com `<a>` em URLs detectadas. */
export function linkify(text: string): ComponentChildren {
  if (!text) return text;
  const parts: ComponentChildren[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    const url = match[0];
    parts.push(
      <a
        href={url}
        target={url.startsWith("mailto:") ? undefined : "_blank"}
        rel="noopener noreferrer"
        class="font-semibold text-primary underline-offset-2 hover:underline break-all"
      >
        {url}
      </a>
    );
    lastIndex = start + url.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return <Fragment>{parts}</Fragment>;
}

/** Extrai a primeira URL de pagamento (que aponta pra /pay/<slug>) de um
 *  texto. Usado pelo modal pra exibir CTA "Abrir link" destacado. */
export function extractPayLink(text: string | null): string | null {
  if (!text) return null;
  const m = text.match(/https?:\/\/[^\s<>"']+\/pay\/[a-z0-9_-]+/i);
  return m ? m[0] : null;
}
